
// elemdirective.js module
function ElemDirective () {}

ElemDirective.processRequired = function(elem, state) {
    elem.find('[data-required-when]').each( function(index, child) {
        let child_elem = jQuery(child)
        let required_when = child_elem.attr('data-required-when')
        let values = required_when.split(',')
        if (values.includes(state)) {
            child_elem.prop('required',true);
        } else {
            child_elem.prop('required',false);
        }
    })
}

ElemDirective.showElement = function(elem, controller_value, condition_value) {
    values = condition_value.split(',')
    if (values.includes(controller_value)) {
        // show the elem
        elem.removeClass('hide')
        ElemDirective.processRequired(elem, 'show')
    } else {
        // hide the elem
        elem.addClass('hide')
        ElemDirective.processRequired(elem, 'hide')
    }
}

ElemDirective.hideElement = function(elem, controller_value, condition_value) {
    values = condition_value.split(',')
    if (values.includes(controller_value)) {
        // hide the element
        elem.addClass('hide')
        ElemDirective.processRequired(elem, 'hide')
    } else {
        // show the element
        elem.removeClass('hide')
        ElemDirective.processRequired(elem, 'show')
    }
}

ElemDirective.initializeElements = function() {

    jQuery('[data-control-with]').each(function (index, value) {
        let elem = jQuery(value);
        let controller_name = elem.attr('data-control-with');
        let show_condition_value = elem.attr('data-show-when');
        let hide_condition_value = elem.attr('data-hide-when');

        let controller = jQuery('#' + controller_name)
        controller.change(function () {
            if (show_condition_value)
            {
                ElemDirective.showElement(elem, controller.val(), show_condition_value);
            }
            if (hide_condition_value)
            {
                ElemDirective.hideElement(elem, controller.val(), hide_condition_value);
            }
        }) // controller.change()

        // initialize the element
        if (show_condition_value)
        {
            ElemDirective.showElement(elem, controller.val(), show_condition_value);
        }
        if (hide_condition_value)
        {
            ElemDirective.hideElement(elem, controller.val(), hide_condition_value);
        }
    }) // data-show-with
}

jQuery(document).ready(function() {
    ElemDirective.initializeElements();
  });
